var _excluded = ["children", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
export var DRAWER_BODY_CLASSNAME = 'drawer__body';
export var DRAWER_BODY_ID = 'drawer__body';
var StyledDrawerBody = styled.div.withConfig({
  componentId: "CL__sc-1lyj9t4-0"
})(["padding:var(--spacing-2) var(--spacing-1);"]);
var DrawerBody = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDrawerBody, _extends({
    id: DRAWER_BODY_ID,
    className: "".concat(className ? "".concat(DRAWER_BODY_CLASSNAME, " ").concat(className) : DRAWER_BODY_CLASSNAME),
    ref: ref
  }, props), children);
});
export default DrawerBody;